
import api from 'api';
import { processPromise, obj2Prams } from '@helpers/functions';

const envio = {};

envio.retrieve = (params = {}) => {
  const querystring = obj2Prams(params);

  return new Promise((resolve, reject) => {
    let endpoint = `/envios`;
    endpoint = querystring ? `${endpoint}?${querystring}` : endpoint;

    api.get(endpoint).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

envio.show = (_id) => {
  return new Promise((resolve, reject) => {
    let endpoint = `/envio/${_id}`;
    api.get(endpoint).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

envio.save = (_id, data) => {
  return new Promise((resolve, reject) => {
    let endpoint = `/envio`;
    endpoint = _id ? `${endpoint}/${_id}` : endpoint;
    api.post(endpoint, data).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

envio.send = (_id) => {
  return new Promise((resolve, reject) => {
    let endpoint = `/enviar/${_id}`;
    api.get(endpoint).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

envio.export = () => {
  return new Promise((resolve, reject) => {
    let endpoint = `/envio/export`;
    api.patch(endpoint, {},{ responseType: 'blob' }).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

export default envio
